import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import Home from "./pages/Home";
import Event from "./pages/Event";
import Inbox from "./pages/Inbox";
import Profile from "./pages/Profile";
import Scan from "./pages/Scan";
import ScanQR from "./pages/ScanQR";
import CreateEvent from "./pages/CreateEvent";
import NotFound from "./pages/NotFound";
import InboxDetail from "./pages/InboxDetail";
import RegisterPage from "./pages/Register";
import { useAuth } from "./helpers/useAuth";
import EventListAdmin from "./pages/EventListAdmin";
import EventDetails from "./pages/EventDetails";
import { useCookies } from "react-cookie";
import { useEffect, useState } from "react";
import { handleLogout } from "./helpers/auth";
import Confirm from "./components/Confirm";
import LoginPage from "./pages/Login";
import Participant from "./pages/Participant";

function App() {
  const [cookies, removeCookie] = useCookies();
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (cookies?.auth?.expiredAt < Date.now()) {
      setOpenModal(true);
    }
  }, [cookies]);

  function sesionExpired() {
    handleLogout(removeCookie);
    setOpenModal(false);
  }

  return (
    <Router>
      <Routes>
        {/* user */}
        <Route element={<OnlyUser redirectTo="/event" />}>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/event/:id" element={<Event />} />
          <Route exact path="/inbox" element={<Inbox />} />
        </Route>
        <Route element={<RequireAuthUser redirectTo="/inbox" />}>
          <Route exact path="inbox/:id" element={<InboxDetail />} />
        </Route>
        <Route element={<RequireAuth redirectTo="/login" />}>
          <Route exact path="/profile" element={<Profile />} />
        </Route>

        {/* admin */}
        <Route element={<RequireAuthAdmin redirectTo="/event" />}>
          <Route exact path="/event" element={<EventListAdmin />} />
          <Route exact path="/event/create" element={<CreateEvent />} />
          <Route exact path="/event/details/:id" element={<EventDetails />} />
          <Route exact path="/scan" element={<Scan />} />
          <Route exact path="/scan/:id" element={<ScanQR />} />
          <Route
            exact
            path="/event/participant/:id"
            element={<Participant />}
          />
        </Route>

        {/* ALL */}
        <Route element={<AuthExist redirectTo="/profile" />}>
          <Route exact path="/login" element={<LoginPage />} />
          <Route exact path="/register" element={<RegisterPage />} />
        </Route>

        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
      <Confirm
        content={{
          title: "Sesi Selesai",
          desc: `Sesi berakhir mohon login ulang`,
        }}
        active={openModal}
        cancelButton={false}
        callback={sesionExpired}
      />
    </Router>
  );
}

export default App;

function OnlyUser({ redirectTo }) {
  const { role } = useAuth();
  return role !== "admin" ? <Outlet /> : <Navigate to={redirectTo} />;
}
function AuthExist({ redirectTo }) {
  const { auth } = useAuth();
  return !auth ? <Outlet /> : <Navigate to={redirectTo} />;
}

function RequireAuthUser({ redirectTo }) {
  const { auth, role } = useAuth();
  return auth && role === "user" ? <Outlet /> : <Navigate to={redirectTo} />;
}
function RequireAuth({ redirectTo }) {
  const { auth } = useAuth();
  return auth ? <Outlet /> : <Navigate to={redirectTo} />;
}

function RequireAuthAdmin({ redirectTo }) {
  const { auth, role } = useAuth();
  const rules = auth && role === "admin";
  return rules ? <Outlet /> : <Navigate to={rules ? redirectTo : "/"} />;
}
